
import Vue from 'vue';
import Component from 'vue-class-component';
import NavBar from '@/components/NavBar/NavBar.vue';
import TheLeagueUser from '@/components/TheLeagueUser.vue';
import { UserModel } from '@/models/user.model';
import { featureKey as leagueFeatureKey } from '@/store/league.store.module';
import { Getter } from 'vuex-class';

@Component({
  components: {
    NavBar,
    TheLeagueUser
  },
  metaInfo() {
    return {
      title: 'Ikone'
    };
  },
})
export default class TheLeaguePage extends Vue {
  defaultPicture: string = require('@/assets/images/profile/no-avatar.svg');
  @Getter('league', { namespace: leagueFeatureKey }) users!: UserModel[];

  get usersGrid() {
    // @ts-ignore
    const offset = this.$vuetify.breakpoint.smAndDown ? -1 : 0;
    const grid = [];
    let odd = false;
    while (this.users.length > 0) {
      grid.push(this.users.splice(0, odd ? 3 + offset : 4 + offset));
      odd = !odd;
    }

    return grid;
  }
}
